var _style, _path, _defs, _text, _path2, _defs2, _text2, _path3, _defs3, _text3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs4, _text4, _defs5, _text5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _text6, _text7, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _text8, _text9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#369;fill-opacity:.502}.st3{fill:#fff}.st4{font-family:&apos;ArialMT&apos;}.st5{font-size:11.4815px}.st8{fill:#bfbfbf}.st10{font-size:13.3596px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 40.1c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M223.7 39.4H250v19.5h-26.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st3 st4 st5",
    transform: "matrix(.9981 0 0 1 233.0171 53.7178)"
  }, "\n    1\n  ")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520.1 40.1c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st1"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M498.2 39.4h26.3v19.5h-26.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_3_"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st3 st4 st5",
    transform: "matrix(.9981 0 0 1 507.5674 53.7178)"
  }, "\n    2\n  ")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.6 151.5c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st1"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M362.8 150.8h26.3v19.5h-26.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_5_"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st3 st4 st5",
    transform: "matrix(.9981 0 0 1 372.1172 165.1182)"
  }, "\n    3\n  ")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344.6 90.4v-5.8H115.4v5.8h229.2z",
    className: "st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M345.4 91.4v-7.5H114.6v7.5h230.8m-1.7-5.9v4.2H116.2v-4.2h227.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5 128.2c.6-2.4.9-5 .8-7.5l-246.2.2c.7 3.9 1.9 7.8 3.7 11.7 2.5 3.1 5.8 4.6 10 4.3 2.4-.1 4.7-.3 6.8-.8 2.3-.5 4.1-.7 5.6-.7 1.2 0 2.5.1 3.8.2.9 0 1.9 0 3.2.1.6 0 1.3 0 2-.1 4 .1 7.5.3 10.5.7 2.4.4 5 .6 7.8.7 1.2.1 2.6 0 4-.2 7-1.3 13.9-3.1 20.7-5.3 5.7-1.3 11.4-1.9 17.2-2 2.8-.1 5.6-.2 8.5-.3 1.4 0 2.9.1 4.3.3 3.8 1.1 7.6 2.4 11.2 4 2.3.8 4.5 1.1 6.6 1.1 3.3-.1 6.6-.5 9.9-1.3 4.5-.8 9-1.3 13.4-1.3 1.2 0 2.4 0 3.6.1 10.7.5 21.4 1.2 32.1 2.2 3.7.4 7.3.6 10.9.6 3.3.1 6.7-.2 9.9-.8 3.5-1.4 6.8-2.8 10-4.2 2.1-.4 3.6-.6 4.3-.5.9 0 3 .4 6.2 1.2 3 .8 5.9 1.3 8.7 1.4.9 0 1.8-.1 2.8-.3 3.6.2 6.1-.9 7.7-3.5z",
    className: "st8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8 120.4l-15.4-26.6-15.4 26.6h30.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.5 92.1l-.8 1.2-16 27.9h33.6l-16.8-29.1m13.8 27.4h-27.9l13.9-24 14 24z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M364.3 121.2v-1.7H108.8v1.7h255.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3 84.7l-18-31.2h-21.4l-18 31.2h57.4z",
    className: "st3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M160.1 53.2l-.3-.5h-22.4l-.3.5-18.7 32.4h60.5l-18.8-32.4m-1.4 1.1l17.2 29.6h-54.8l17.2-29.6h20.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8 84.7l-17.9-31.2h-21.5l-18 31.2h57.4z",
    className: "st3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M339.3 85.5l-19-32.9h-22.4l-.3.5-18.7 32.4h60.4m-20.1-31.2l17.2 29.6h-54.8l17.2-29.6h20.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M271.7 97.3v-6.8h-83.5v6.8h13.9v-3.7h6v3.7h6.5v-3.7h5.8v3.7h6.7v-3.7h5.8v3.7h6.5v-3.7h5.8v3.7h6.7v-3.7h5.8v3.7h14z",
    className: "st3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 98.1v-8.5h-85.2v8.5h15.5v-3.7h4.3v3.7h8.2v-3.7h4.2v3.7h8.4v-3.7h4.2v3.7h8.2v-3.7h4.2v3.7h8.4v-3.7h4.2v3.7h15.4m-1.6-6.8v5.2h-12.2v-3.7h-7.5v3.7h-5v-3.7h-7.5v3.7h-4.8v-3.7h-7.5v3.7h-5v-3.7h-7.5v3.7h-4.8v-3.7h-7.7v3.7H189v-5.2h81.9z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M127.7 64.6h35.7v21.6h-35.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_7_"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st10",
    transform: "matrix(1.0001 0 0 1 131.2319 80.0566)"
  }, "\n    25kg\n  ")), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M288.4 64.6h35.7v21.6h-35.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_9_"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st10",
    transform: "matrix(1.0001 0 0 1 291.8818 80.0566)"
  }, "\n    50kg\n  ")), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M622.2 90.4v-5.8H392.9v5.8h229.3z",
    className: "st3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M623.1 91.4v-7.5h-231v7.5h231m-1.7-5.9v4.2H393.8v-4.2h227.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M638.3 128.2c.6-2.4.9-5 .8-7.5l-246 .2c.7 3.9 1.8 7.8 3.5 11.7 2.5 3.1 5.8 4.6 10 4.3 2.4-.1 4.7-.3 6.8-.8 2.2-.5 4-.7 5.3-.7 1.1 0 2.3.1 3.4.2.8 0 1.8 0 3 .1.6 0 1.3 0 2-.1 4 .1 7.3.3 10 .7 2.1.4 4.5.6 7.3.7 1.2.1 2.5 0 3.9-.2 6.9-1.3 13.8-3.1 20.7-5.3 5.6-1.3 11.4-1.9 17.2-2l8.4-.3c1.4 0 2.9.1 4.3.3 4 1.1 7.7 2.4 11.4 4 2.3.8 4.5 1.1 6.6 1.1 3.3-.1 6.6-.5 9.9-1.3 4.5-.8 9-1.3 13.4-1.3 1.2 0 2.4 0 3.6.1 10.7.5 21.4 1.2 32.1 2.2 3.6.4 6.8.6 9.6.6 2.6.1 5.5-.2 8.8-.8 4.1-1.4 8.2-2.8 12.5-4.2 2.1-.4 3.8-.6 4.9-.5 1.7 0 4.2.4 7.6 1.2 3 .8 5.9 1.3 8.7 1.4.9 0 1.8-.1 2.8-.3 3.4.2 5.9-.9 7.5-3.5z",
    className: "st8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M535.3 120.4l-15.2-26.6-15.4 26.6h30.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M520.2 92.1l-.8 1.2-16 27.9H537l-16.8-29.1m13.9 27.4h-27.9l13.9-24 14 24z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M641.2 121.2v-1.7H388.4v1.7h252.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M455 84.7l-18-31.2h-21.5l-18 31.2H455z",
    className: "st3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M437.7 53.2l-.2-.5H415l-.2.5-18.7 32.4h60.3l-18.7-32.4m-1.2 1.1l17 29.6h-54.6l17-29.6h20.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M615.5 84.7l-18-31.2H576l-18 31.2h57.5z",
    className: "st3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M598.2 53.2l-.2-.5h-22.5l-.2.5-18.7 32.4h60.5l-18.9-32.4m-1.2 1.1l17.2 29.6h-54.8l17.2-29.6H597z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M549.4 97.3v-6.8h-83.5v6.8h13.9v-3.7h5.8v3.7h6.7v-3.7h5.8v3.7h6.5v-3.7h5.8v3.7h6.7v-3.7h5.8v3.7h6.5v-3.7h5.8v3.7h14.2z",
    className: "st3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M550.2 98.1v-8.5H465v8.5h15.5v-3.7h4.2v3.7h8.4v-3.7h4.2v3.7h8.2v-3.7h4.2v3.7h8.4v-3.7h4.2v3.7h8.2v-3.7h4.2v3.7h15.5m-1.7-6.8v5.2h-12.4v-3.7h-7.5v3.7h-4.8v-3.7h-7.5v3.7h-5v-3.7h-7.5v3.7H499v-3.7h-7.5v3.7h-5v-3.7H479v3.7h-12.2v-5.2h81.7z"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st10",
    transform: "matrix(1.0001 0 0 1 409.2812 80.0566)"
  }, "\n    50kg\n  ")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st10",
    transform: "matrix(1.0001 0 0 1 569.6143 78.2197)"
  }, "\n    25kg\n  ")), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M491 190.7v-6H261.7v6H491z",
    className: "st3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M491.9 191.3v-7.7h-231v7.7h231m-1.7-6v4.3H262.6v-4.3h227.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M504.9 228c.6-2.4.8-4.9.7-7.5l-266.2.3c.7 3.8 1.8 7.7 3.5 11.7 2.6 3.1 5.8 4.5 9.9 4.3 2.5-.1 4.9-.4 7.2-.9 2.1-.4 4.1-.6 6-.6 1.6 0 3.2.1 4.8.3 1.3 0 2.7 0 4.1.1.7 0 1.5 0 2.3-.1.7-.1 1.5-.1 2.3-.1 3.5.1 7 .3 10.6.8 3.4.3 6.8.5 10.1.6 1.5 0 3-.1 4.4-.3 6.9-1.3 13.8-3.1 20.7-5.3 5.7-1.3 11.4-1.9 17.2-1.8 2.7-.2 5.3-.3 8-.4 1.6 0 3.1.1 4.7.4 4 1 7.7 2.3 11.4 4 2.1.7 4.2 1.1 6.3 1 3.3-.1 6.8-.6 10.3-1.3 4.7-.8 9.5-1.2 14.3-1.2.9-.1 1.8-.1 2.8 0 10.8.6 21.5 1.4 32.1 2.3 3.5.3 7 .5 10.5.6 3.5 0 6.9-.3 10.4-.8 4.8-1.3 9.6-2.8 14.4-4.3 2.2-.3 4.5-.5 6.8-.5 4 0 7.9.4 11.8 1.3 3.1.8 6.1 1.3 8.9 1.4.9 0 1.8-.1 2.8-.3 2.8.1 5.2-1.1 6.9-3.7z",
    className: "st8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M391.6 220.4l-15.2-26.6-15.4 26.6h30.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M359.5 221.1h33.6L376.4 192l-16.9 29.1m30.6-1.7h-27.7l13.9-23.9 13.8 23.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M510.5 221v-1.7H234.8v1.7h275.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M323.7 184.5l-18-31.1h-21.5l-18 31.1h57.5z",
    className: "st3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M325.1 185.3l-18.9-32.7h-22.5l-18.9 32.7h60.3m-19.8-31l16.9 29.4h-54.4l16.9-29.4h20.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M484.3 184.5l-18-31.1h-21.5l-18 31.1h57.5z",
    className: "st3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M485.7 185.3l-18.9-32.7h-22.5l-18.9 32.7h60.3m-19.8-31l16.9 29.4h-54.4l16.9-29.4h20.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M418.2 197.3v-6.8h-83.7v6.8h14v-3.7h5.8v3.7h6.5v-3.7h6v3.7h6.5v-3.7h5.8v3.7h6.7v-3.7h5.8v3.7h6.5v-3.7h5.8v3.7h14.3z",
    className: "st3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M418.9 198.2v-8.5h-85.3v8.5h15.7v-3.7h4.2v3.7h8.2v-3.7h4.3v3.7h8.2v-3.7h4.2v3.7h8.4v-3.7h4.2v3.7h8.2v-3.7h4.2v3.7h15.5m-1.6-6.9v5.2h-12.4v-3.7h-7.5v3.7h-4.8v-3.7H385v3.7h-5v-3.7h-7.5v3.7h-4.8v-3.7H360v3.7h-4.8v-3.7h-7.5v3.7h-12.4v-5.2h82z"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st10",
    transform: "matrix(1.0001 0 0 1 278.5317 179.8066)"
  }, "\n    50kg\n  ")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st10",
    transform: "matrix(1.0001 0 0 1 438.7637 177.9697)"
  }, "\n    25kg\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem10);
export default __webpack_public_path__ + "static/media/item10.37c314c15fcaabbbf21aa06af9104bed.svg";
export { ForwardRef as ReactComponent };